export default __webpack_public_path__ + "static/section_13-175c2d049005f853841847940f3fec8b.png";